export const API_URL =
  process.env.REACT_APP_ENV === "production"
    ? "https://api.stratic.app/api/v1/"
    : process.env.REACT_APP_ENV === "development"
    ? "https://samapi.helm.design/api/v1/"
    : "http://localhost:4899/api/v1/";

export const SPOTTRAC_KEY = "0ad9c4dc803d775377e24edd69f1628d";
export const SPOTTRAC_API_URL = "https://www.spotrac.com/api/stratic/";
export const SPOTTRAC_PLAYER = "25102";

export const notificationURLTypes = Object.freeze({
  Global: "dashboard",
  Events: "event",
  Educations: "article",
  Contacts: "leagueaccess",
});

export const notificationTypes = Object.freeze({
  GLOBAL: "Alert",
  EVENT: "Events",
  EDUCATION: "Education",
  PROFESSIONAL_SERVICE: "Professional Services",
  LEAGUE_ACCESS: "League Contacts",
  CONTACT: "Contacts",
  ARCHIVE: "Archived",
  TWITTER: "Twitter",
  ITL: "ITL",
});

export const playerTypes = Object.freeze({
  ROOKIE: "Rookie",
  VETERAN: "Veteran",
  VESTED_VETERAN: "Vested Veteran",
});

export const playerStatusTypes = Object.freeze({
  ACTIVE: "Active",
  FREE_AGENT: "Free Agent",
  INJURED: "Injured Reserve",
  RETIRED: "Retired",
  PUP: "PUP",
  NFI: "NFI",
  PRACTICE_SQUAD: "Practice Squad",
  DRAFT_PROSPECT: "Draft Prospect",
  PROSPECT: "Prospect",
});

export const collegePlayerStatusTypes = Object.freeze({
  ACTIVE: "Active",
  INJURED: "Injured",
  FREE_AGENT: "Free Agent",
  RETIRED: "Retired",
});

export const userTypes = Object.freeze({
  AGENT: "Agent",
  COACH: "Coach",
  EXECUTIVE: "Executive",
  PARENT: "Parent",
  SPOUSE: "Spouse",
  PLAYER: "Professional Player",
  REPORTER: "Reporter",
  COLLEGE: "College Player",
});

export const collegePlayerTypes = Object.freeze({
  FRESHMAN: "Freshman",
  REDSHIRT_FRESHMAN: "Redshirt Freshman",
  SOPHOMORE: "Sophomore",
  REDSHIRT_SOPHOMORE: "Redshirt Sophomore",
  JUNIOR: "Junior",
  REDSHIRT_JUNIOR: "Redshirt Junior",
  SENIOR: "Senior",
  REDSHIRT_SENIOR: "Redshirt Senior",
  GRADUATE: "Graduate",
});
